import axiosInstance from "../redux/api";

const DEFAULT_MAX_BYTES = 5 * 1024 * 1024;

const sanitizeUploadFileName = (name) => {
  const base = (name || "image").split(/[/\\]/).pop();
  const cleaned = base.replace(/[^a-zA-Z0-9._-]/g, "_").replace(/_+/g, "_");
  return cleaned.length > 0 ? cleaned : "image.png";
};

export const uploadImageToS3 = async (
  file,
  { folder = "images", maxBytes = DEFAULT_MAX_BYTES, allowedTypes } = {},
) => {
  if (Array.isArray(allowedTypes) && allowedTypes.length > 0) {
    if (!allowedTypes.includes(file?.type)) {
      throw new Error(
        `Unsupported image type. Allowed: ${allowedTypes
          .map((t) => t.replace("image/", "").toUpperCase())
          .join(", ")}`,
      );
    }
  } else if (!file?.type?.startsWith("image/")) {
    throw new Error("Please upload an image file");
  }
  if (file.size > maxBytes) {
    const limitMB = Math.round(maxBytes / (1024 * 1024));
    throw new Error(`File size should be less than ${limitMB}MB`);
  }

  const fileName = `${Date.now()}-${sanitizeUploadFileName(file.name)}`;
  const { data } = await axiosInstance.post("auth/s3-url", {
    file_name: fileName,
    file_type: file.type,
    folder,
  });
  const { upload_url, file_url } = data?.response || {};
  if (!upload_url || !file_url) {
    throw new Error("Failed to obtain upload URL");
  }

  const putResponse = await fetch(upload_url, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });
  if (!putResponse.ok) {
    throw new Error("Failed to upload to S3");
  }

  return { file_url };
};
